export const getAllowedSportCodes = () => {
    return process.env.REACT_APP_SPORT_ID?.split(",") || [];
};
